import * as Sentry from '@sentry/browser';

import ContactList from './modules/contact-list';
window.ContactList = ContactList;

import LegacyShowHide from './modules/legacy/show-hide';
document.addEventListener('DOMContentLoaded', () => {
	new LegacyShowHide();
});

import { improveFilamentScroll } from './utils/improve-scroll';
improveFilamentScroll();

import { fixFilamentSearchable } from './utils/fix-searchable';
fixFilamentSearchable();

import.meta.glob(['../images/**', '../fonts/**']);

Sentry.init({
	environment: import.meta.env.VITE_APP_ENV,

	dsn: import.meta.env.VITE_SENTRY_DSN,

	integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

	// Set tracesSampleRate to capture 5%
	// of transactions for performance monitoring.
	tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,

	// Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: [
		'localhost',
		/^127\.0\.0\.1:\d+$/,
		/^https:\/\/gigsalad\.test/,
		/^https:\/\/gigsalad\.com/,
	],

	// Capture Replay for 0% of all sessions,
	// plus for 25% of sessions with an error
	replaysSessionSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
	replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
});

// Add user identification to Sentry
if (window.GS && window.GS.user) {
	Sentry.setUser(window.GS.user);
}
